import { PopularDestinations } from '@/core/domain/popular-destinations/models/popular-destinations.model';
import { PopularDestinationsRepository } from '@/core/domain/popular-destinations/repositories/popular-destinations.repository';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PopularDestinationsImplRepository extends PopularDestinationsRepository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override getPopularDestinations(): Observable<PopularDestinations> {
        return this.httpClient
            .get(
                [
                    environment.alamoApi.BASE_HOST,
                    environment.alamoApi.ENDPOINTS.popularDestinations,
                ].join('/'),
            )
            .pipe(
                switchMap(
                    (popularDestinationsResponse: PopularDestinations) => {
                        const popularDestinations: PopularDestinations = {
                            type: popularDestinationsResponse.type,
                            action: popularDestinationsResponse.action,
                            notifications:
                                popularDestinationsResponse.notifications,
                            data: popularDestinationsResponse.data,
                        };

                        return of(popularDestinations);
                    },
                ),
            );
    }
}
